import React, { Component, Fragment } from 'react';
import Card from 'react-bootstrap/Card';
import '../../../css/card.css';
import Axios from '../../../config/axios';
import Globals from '../../../config/globals';
import { Modal } from 'react-bootstrap';
import googlePlayImg from '../../../img/g_play.png';
import appStoreImg from '../../../img/a_store.png';
import NumberFormat from 'react-number-format';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import { message } from 'antd';
import * as ShowSliders from '../ShowSliders/index';

export class ExhibitorInviteProgramCard extends Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.showInfo.name !== prevState.showInfo.name && nextProps.showInfo.show_abbrev !== prevState.showInfo.show_abbrev) {
            return { showInfo: nextProps.showInfo }
        }

        return null;
    }

    constructor(props) {
        super(props);
        this.state = {
            showInfo: this.props.showInfo,
            showInstructionModal: false,
            showOrderModal: false,
            formFields: {},
            showOrderModalForm: true,
            showETicketSlider: false,
            showD2PLogoSlider: false,
            showD2PVideoSlider: false
        }
    }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ formFields: { ...this.state.formFields, [name]: value } });
    }



    render() {

        return (
            <Card className="showCard">
                <Card.Header><span>Free Exhibitor Promotional Tools</span></Card.Header>
                <Card.Body>
                    <div className="d-flex flex-column align-items-center">
                        <button
                            type="button"
                            className="btn btn-primary mb-3"
                            style={{ minWidth: '220px' }}
                            onClick={() => this.setState({ showETicketSlider: true })}
                        >
                            Exhibitor Invite Ticket
                        </button>

                        <button
                            type="button"
                            className="btn btn-primary mb-3"
                            style={{ minWidth: '220px' }}
                            onClick={() => this.setState({ showD2PLogoSlider: true })}
                        >
                            Design-2-Part Logo
                        </button>

                        <button
                            type="button"
                            className="btn btn-primary"
                            style={{ minWidth: '220px' }}
                            onClick={() => this.setState({ showD2PVideoSlider: true })}
                        >
                            Design-2-Part Promo Video
                        </button>
                    </div>
                </Card.Body>

                <ShowSliders.ETicketSlider showPane={this.state.showETicketSlider} showCode={this.props.showInfo?.showcode} hidePane={() => this.setState({ showETicketSlider: false })} {...this.props} />
                <ShowSliders.D2PLogoSlider showPane={this.state.showD2PLogoSlider} showCode={this.props.showInfo?.showcode} hidePane={() => this.setState({ showD2PLogoSlider: false })} {...this.props} />
                <ShowSliders.D2PVideoSlider showPane={this.state.showD2PVideoSlider} showCode={this.props.showInfo?.showcode} hidePane={() => this.setState({ showD2PVideoSlider: false })} {...this.props} />
            </Card>
        );
    }
}